import { render, staticRenderFns } from "./PriceUpdateModal.vue?vue&type=template&id=378cbaa4&"
import script from "./PriceUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PriceUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports